export default "Studie zum Zusammenhang von Krebs-Coping-Selbstwirksamkeit, Symptombelastung und Lebensqualität bei Krebsüberlebenden."